import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserPageSF from '../../../templates/SuperUserPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LoanListNavUI from '../../../components/superUser/loanList/LoanListNavUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import RepaymentInitiatedListSF from '../../../components/superUser/loanList/RepaymentInitiatedListSF'

const RepaymentInitiatedListPageUI = ({context, errorList, repaymentList, filteredTransactionList,
    searchFilter, onSearchFilterChange, onRefreshClick,
  }) =>
  <SuperUserPageSF context={context} className='pg_su_txn_l' topnav='loans'
    headerText='Pending transactions' centered={!repaymentList && !errorList}
  >
    {
      !repaymentList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      repaymentList && repaymentList.length !== 0 &&
      <div>
        <LoanListNavUI page='initiated' />

        <RepaymentInitiatedListSF context={context} repaymentList={repaymentList}
          onRefreshClick={onRefreshClick}
          searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
        />
      </div>
    }
    {
      repaymentList && repaymentList.length === 0 &&
      <div>
        <LoanListNavUI page='initiated' />

        <div className='g_flex_h g_m_top_100'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
        </div>
        <EmptyListUI
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No pending repayments'
        />
      </div>
    }
  </SuperUserPageSF>

export default RepaymentInitiatedListPageUI
